<app-loader [Parent]="this"></app-loader>
@if (FormLoaded) {
  <div>
    <app-pageheader [Parent]="this">
      <a class="button is-primary" [routerLink]="['/enforcement/voidreasons', Model.Id, 'edit']">
        <span class="icon"><i class="fas fa-edit"></i></span>
        <span>Edit Void Reason</span>
      </a>
    </app-pageheader>
    <div class="columns">
      <div class="column is-6">
        <article class="panel">
          <p class="panel-heading">Void Reason</p>
          <a class="panel-block">
            <span class="label">Text</span>
            <span class="value">{{Model.Text}}</span>
          </a>
          <a class="panel-block">
            <span class="label">Description</span>
            <span class="value">{{Model.Description || 'N/A'}}</span>
          </a>
          <a class="panel-block">
            <span class="label">Counts Against Performance</span>
            <span class="value">
              <span class="tag" [ngClass]="Model.CountsAgainstPerformance ? 'is-warning' : 'is-success'">
                {{Model.CountsAgainstPerformance ? 'Yes' : 'No'}}
              </span>
            </span>
          </a>
          <a class="panel-block">
            <span class="label">Publicly Visible</span>
            <span class="value">
              <span class="tag" [ngClass]="Model.PubliclyVisible ? 'is-info' : 'is-light'">
                {{Model.PubliclyVisible ? 'Yes' : 'No'}}
              </span>
            </span>
          </a>
        </article>
      </div>
      <div class="column is-6">
        <article class="panel">
          <p class="panel-heading">Attribute Information</p>
          <div class="panel-block is-block">
            <div class="content">
              @if (Model.CountsAgainstPerformance) {
                <p class="has-text-warning">
                  <span class="icon"><i class="fas fa-exclamation-triangle"></i></span>
                  Voids using this reason will count against the issuing officer's performance metrics.
                </p>
              }
              @if (!Model.CountsAgainstPerformance) {
                <p class="has-text-success">
                  <span class="icon"><i class="fas fa-check-circle"></i></span>
                  Voids using this reason will not affect officer performance metrics.
                </p>
              }
              <hr>
                @if (Model.PubliclyVisible) {
                  <p class="has-text-info">
                    <span class="icon"><i class="fas fa-eye"></i></span>
                    This reason will be visible to the public when a citation is voided.
                  </p>
                }
                @if (!Model.PubliclyVisible) {
                  <p class="has-text-grey">
                    <span class="icon"><i class="fas fa-eye-slash"></i></span>
                    This reason will only be visible internally.
                  </p>
                }
              </div>
            </div>
          </article>
        </div>
      </div>
    </div>
  }

